import React from "react";
import { Controller, useFormContext } from "react-hook-form";
// import InputText from "../InputText";
import InputMonetary from "../InputMonetary/index";


const ValueOfTheLossInput = () => {
    const { control, formState: { errors } } = useFormContext();

    return (
        <Controller
            name="ValueOfTheLoss"
            control={control}
            render={({ field }) => (
                <InputMonetary
                    id="ValueOfTheLoss"
                    name="ValueOfTheLoss"
                    title="Valor estimado do prejuízo"
                    placeholder="R$ 0,00"
                    hasError={!!errors?.ValueOfTheLoss?.message}
                    errorMessage={errors?.ValueOfTheLoss?.message}
                    value={field.value}
                    onChange={(value) => field.onChange(value)}
                    {...field}
                />
            )}
        />
    );
};

export default ValueOfTheLossInput;